import { all } from "redux-saga/effects";
import { planLopTinChiSaga } from "./planLopTinChiSaga";
import { danhSachLopTinChiSaga } from "./danhSachLopTinChiSaga";

export default function* lopTinChiSagaWrapper() {
  yield all([planLopTinChiSaga(), danhSachLopTinChiSaga()]);
}
